var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-wiki-top"},[_vm._m(0),_c('div',{staticClass:"m-wiki-top__content",domProps:{"innerHTML":_vm._s(_vm.data)}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-wiki-top__header"},[_c('h3',{staticClass:"u-title"},[_c('i',{staticClass:"el-icon-news"}),_vm._v("公告")])])
}]

export { render, staticRenderFns }